import { Carousel } from '@pcln/horizon'
import { useMemo } from 'react'

import PackageCard from './PackageCard'
import type { DealDataResponse } from './types'

export default function PackagesDealCarousel({
  deals,
}: Readonly<{
  deals: DealDataResponse[]
}>) {
  const slides = useMemo(
    () =>
      deals.map((deal, index) => ({
        id: deal.cityImageUrl ?? `deal-${index}`,
        childrenNodes: <PackageCard key={deal.cityImageUrl} index={index} deal={deal} />,
      })),
    [deals],
  )

  return (
    <Carousel
      ariaLabel='Hotel and flight package deals'
      dragFree
      numSlides='one-two-three'
      slides={slides}
      slideWidth='same'
      type='content'
    />
  )
}
